module.exports = __webpack_public_path__ + "img/ic_feedback_shared.ff275e34.png";